import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { EmployeeDataTableService } from 'src/app/views/employee-data-table/employee-data-table.service';

@Component({
  selector: 'app-date-range-dialog-component',
  templateUrl: './date-range-dialog-component.html',
  styleUrls: ['./date-range-dialog-component.css']
})
export class DateRangeDialogComponentComponent {
  constructor(@Optional() public dialogRef: MatDialogRef<DateRangeDialogComponentComponent>, private service: EmployeeDataTableService, private Toaster: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  fromDate: string = "";
  toDate: string = "";
  invalid: boolean = false;
  ngOnInit() {
  }
  convertToDdMmYyyy(dateString: string) {
    const date = new Date(dateString);

    // Ensure the date object is valid
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date string');
    }

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const yyyy = date.getFullYear();

    return `${yyyy}/${mm}/${dd}`;
  }
  myDateFilter = (d: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return d ? d <= tomorrow : false;
  }
  cancel() {
    this.dialogRef.close();
  }
  confirm() {
    if (((this.fromDate == "") || (this.toDate == "")) || ((this.toDate < this.fromDate))) { this.invalid = true; return; }
    this.invalid = false;
    this.toDate = this.convertToDdMmYyyy(this.toDate);
    this.fromDate = this.convertToDdMmYyyy(this.fromDate);
    this.dialogRef.close({
      fromDate: this.fromDate,
      toDate: this.toDate
    });

  }

}
